import { Component, OnInit } from '@angular/core';
import { Customers } from '../../models/customers';
import { UsersService } from '../../services/users.service';

@Component({
  selector: 'app-customers',
  templateUrl: './customers.component.html',
  styleUrls: ['./customers.component.scss']
})
export class CustomersComponent implements OnInit {
  public customers = [];

  constructor(private userService: UsersService) { }

  ngOnInit(): void {
    this.userService.getUsers().subscribe(data => {
      this.customers = data.map(e => {
        return {
          id: e.payload.doc.id,
          name: e.payload.doc.data()['name'],
          email: e.payload.doc.data()['email'],
          age: e.payload.doc.data()['age'],
          country: e.payload.doc.data()['country'],
          interest: e.payload.doc.data()['interest'],
        };
      })
      console.log(this.customers);
    });
  }

}
